import React from 'react';
import './Banner.scss';
import Logo from '../../../../assets/icons/Vector_gold_v2.svg';
const Background = require('../../../../assets/images/inside_2.png');

const Banner = () => {
  return (
    <section className='main-banner-section section-common'>
      <div className='decoration' />
      <img className='background' src={Background} alt="zdęcie zlota centrum zdrowia" />
               <div className="wrapper">      
               <div className="service-banner-img">
                    <img src={Logo} alt="logo zlota centrum zdrowia" />
                   </div>
      </div>
    </section>
    
  );
};

export default Banner;